import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 73135 72056"
    {...props}
  >
    <path
      d="M36567 1045c0 27562-4918 29353-23185 8438C31649 30398 29032 34929 1045 30852c27987 4078 28896 9233 4284 24300 24611-15067 28621-11703 18902 15860 9719-27563 14952-27563 24673 0-9720-27563-5710-30927 18901-15860-24611-15067-23702-20222 4285-24300-27988 4078-30605-454-12337-21369-18268 20915-23186 19124-23186-8438z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 2089.56,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
